import {createAction} from "typesafe-actions";

export const setMainObjective = createAction("MAIN_OBJECTIVE/set", (objective: string) => ({objective}))();
